<template>
  <div>
    <!-- ヘッダ -->
    <comHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="companyname"></comHeaderAuth>
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="warning" elevation="2">
          {{ messageArea }}
        </v-alert>
        <!-- プラン情報 -->
        <v-row justify="center" align-content="center">
          <v-col cols="12" sm="10" md="10" lg="9" xl="9">
            <v-expansion-panels :tile="true" v-model="panelNoPlanInfo">
              <v-expansion-panel>
                <v-expansion-panel-header
                  expand-icon="mdi-menu-down"
                  class="panel-title"
                >
                  <label>申込プラン</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mt-4">

                  <span v-html="dispPlanIdNm"></span>

                  <v-card color="grey lighten-3" flat>
                    <v-card-text class="px-1 px-sm-4" style="background:white;">
                          
                      <v-simple-table class="py-4 px-0 px-sm-0 px-md-6 px-xl-10">
                        <thead>
                          <tr>
                            <th class="text-center" style="width:53%">プラン名</th>
                            <th class="text-center" style="width:10%"></th>
                            <th class="text-center">報酬額</th>
                            <th class="text-center px-0">登録免許税又は印紙税等</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in planDesserts" :key="item.planName" style="background-color: white !important;" >
                            <template v-if="item.planName === '小計'" >
                              <td class="" style="background-color: #ffffff;border:0;"></td>
                              <td class="text-right text-caption text-sm-body-1 text-md-body-1" style="background-color: #BDBDBD;">
                                {{ item.planName }}
                              </td>
                              <td class="text-right px-0 text-caption text-sm-body-1" style="background-color: #F5F5F5;">
                                <template v-if="Number(item.planReward) > 0">{{ item.planReward.toLocaleString() }}円</template>
                                <template v-else></template>
                              </td>
                              <td class="text-right pr-2 text-caption text-sm-body-1" style="background-color: #F5F5F5;">
                                <template v-if="Number(item.planTax) > 0">{{ item.planTax.toLocaleString() }}円</template>
                                <template v-else></template>  
                              </td>
                            </template>
                            <template v-else-if="item.planName === '合計'  || item.planName === '消費税10%'  || item.planName === '請求金額'" >
                              <td class="" style="background-color: #ffffff;border:0;"></td>
                              <td class="text-right text-caption text-sm-body-1 text-md-body-1" style="background-color: #BDBDBD;">
                                {{ item.planName }}
                              </td>
                              <td class="" style="background-color: #F5F5F5;"></td>
                              <td class="text-right px-2 text-caption text-sm-body-1" style="background-color: #F5F5F5;">
                                <template v-if="Number(item.planReward) > 0">{{ item.planReward.toLocaleString() }}円</template>
                                <template v-else></template>
                              </td>
                            </template>
                            <template v-else>
                              <td class="text-left text-caption text-sm-body-1 text-md-subtitle-1" style="background-color: #F5F5F5;">{{ item.planName }}</td>
                              <td class="" style="background-color: #ffffff;;"></td>
                              <td class="text-right px-0 text-caption text-sm-body-1" >
                                <template v-if="Number(item.planReward) >= 0">{{ item.planReward.toLocaleString() }}円</template>
                                <template v-else></template>
                              </td>
                              <td class="text-right pr-2 text-caption text-sm-body-1">
                                <template v-if="Number(item.planTax) > 0">{{ item.planTax.toLocaleString() }}円</template>
                                <template v-else></template>  
                              </td>
                            </template>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>



                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <!-- 登記情報ファイル情報 -->
        <!-- <v-row justify="center" align-content="center">
          <v-col cols="12" sm="10" md="10" lg="9" xl="9">
            <v-expansion-panels :tile="true" v-model="panelNoFileInfo">
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="panel-title"
                  expand-icon="mdi-menu-down"
                >
                  <label class="moji mojihead">登記情報ファイル</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mt-4" >
                  <span>
                    <p>ファイル名：{{ dispFileNm }}</p>
                    <p>サイズ：{{ dispFileSize }} バイト</p>
                  </span>
                  <iframe id="iframeFile" :src="dispPdfFileBlobUrl" width="100%"></iframe>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row> -->
        <!-- 役員情報 -->
        <v-row justify="center" align-content="center">
          <v-col cols="12" sm="10" md="10" lg="9" xl="9">
            <v-expansion-panels :tile="true" v-model="panelNoOfficerInfo">
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="panel-title"
                  expand-icon="mdi-menu-down"
                >
                  <label class="moji mojihead">役員情報</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="pl-2 pt-6">
                    <v-col cols="12">
                      <span v-html="dispChangeOfficerDate"></span>
                    </v-col>
                  </v-row>
                <v-data-table
                  :headers="headers"
                  :items="dispOfficerList"
                  :single-expand="dispOfficerSingleExpand"
                  :expanded.sync="expanded"
                  :key="isMobile ? expanded.length : ''"
                  item-key="no"
                  show-expand 
                  disable-pagination
                  hide-default-footer
                  :disable-sort="true"
                  calculate-widths
                  class="v-data-table elevation-3 v-dtbl-md-1 mt-5"
                >
                  <template v-slot:[`item.officer`]="{ item }">
                    {{ item.officer.name }}
                  </template>
                  <template v-slot:[`item.reason`]="{ item }">
                    {{ item.reason.name }}
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <div class="expand-box">
                        <span class="box-title">役員住所</span>
                        <p v-html="item.address"></p>
                      </div>       
                    </td>
                  </template>
                  <!-- <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <div class="expand-box">
                        <span class="box-title">役員変更詳細</span>
                        <p v-html="item.detailInfo"></p>
                      </div>       
                    </td>
                  </template> -->
                </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <!-- 登記変更詳細情報 -->
        <!-- <v-row justify="center" align-content="center">
          <v-col cols="12" sm="10" md="10" lg="9" xl="9">
            <v-expansion-panels :tile="true" v-model="panelNoDatailInfo">
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="panel-title"
                  expand-icon="mdi-menu-down"
                >
                  <label class="moji mojihead">登記変更詳細情報</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mt-4">
                  <span v-html="dispRegChgInfo"></span>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col cols="12">
            <v-sheet min-height="1vh" color="transparent"></v-sheet>
          </v-col>
        </v-row>
        <!-- ボタン -->
        <v-row justify="center" align-content="start">
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <v-btn  :disabled="isProcessing" x-large color="warning"  min-width="200px" @click="requestRegist()" >申し込む</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
              <v-btn x-large color="warning"  min-width="200px" @click="back()">修正する</v-btn>
          </v-col>
        </v-row>
        <!-- 注意喚起(吹き出し) -->
        <v-row justify="start" align-content="center">
          <v-col cols="12" sm="5" md="5" lg="5" xl="4" class="d-flex align-start justify-start">
           <v-card class="ml-auto" max-width="100px" color="transparent" flat >
              <v-img src="../assets/img/tqsman-big.png"></v-img>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-start justify-start">
            <div class="balloon mt-0" >
              申し込むボタンをクリックしてください。<br />これで登記変更のお申し込みは完了です。<br />上記内容を変更する場合は、修正するボタンをクリックしてください。
            </div>
          </v-col>
        </v-row>

        <!-- その他 -->
        <comMessageConfirm :msg="dlgMsgConfirm.msg" :isOpen="dlgMsgConfirm.isOpen" :doYes="dlgMsgConfirm.doYes" :doNo="dlgMsgConfirm.doNo" />
        <comMessage :msg="dlgMsgCompled.msg" :isOpen="dlgMsgCompled.isOpen" :doYes="dlgMsgCompled.doYes"/>
        <comMessage :msg="dlgMsgErr.msg" :isOpen="dlgMsgErr.isOpen" :doYes="dlgMsgErr.doYes"/>
        <v-fab-transition>
          <v-btn
            color="indigo"
            fab
            dark
            large
            absolute
            right
            style="bottom:20px; position:fixed;"
            @click="$vuetify.goTo(0)"  
            v-show="buttonActive"
          >
            <v-icon>mdi-navigation</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import Constants from "../common/constants";
import Utils from "../common/utils";
export default {
  name: "InputRequestConfirmRegist",
  props: ["srcViewId", "requestId"],
  data() {
    return {
      username: "",
      companyname: "",
      screenTitle: "お申込み内容確認",
      screenId: "MBR510",
      messageArea: "",
      moveTopButton: 'right',
      planMstList: null,
      reasonMstrList: null,
      selectedPlanIdList: null,
      dispRequesuDate: "",
      dispPlanIdNm: "",
      dispFileInfo: null,
      dispFileNm: "",
      dispFileSize: "",
      // dispLastModifiedDate: "",
      dispPdfFileBlobUrl: null,
      dispChangeOfficerDate: "",
      appointDate: "",
      resignDate: "",
      othersDate: "",
      dispOfficerList: null,
      dispOfficerSingleExpand: true,
      dispRegChgInfo: "",
      panelNoPlanInfo: 0,
      panelNoFileInfo: 0,
      panelNoOfficerInfo: 0,
      panelNoDatailInfo: 0,

      buttonActive: false,
      scroll: 0,

      isProcessing: false,

      isMobile: false,
      expanded: [],

      dlgMsgConfirm: {
        msg: this.$i18n.t('msg.wrn.mb020'),
        isOpen: false,
        doYes: () => {
          // 申込登録
          this.request();
          this.dlgMsgConfirm.isOpen = false;
          this.isProcessing = false;
        },
        doNo: () => {
          this.dlgMsgConfirm.isOpen = false;
          this.isProcessing = false;
        },
      },
      dlgMsgCompled: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgCompled.isOpen = false;
          this.$router.push(this.$router.resolve({ name: "MBR600" }).href);
        },
      },
      dlgMsgErr: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgErr.isOpen = false;
        },
      },
      headers: [
        { text: "No", align: "start", value: "no", width: "7%"  },
        { text: "資格(役員役職)", align: "start", value: "officer", width: "15%" },
        // { text: "資格(役員役職)", align: "start", value: "officerNm", width: "15%" },
        { text: "氏名", align: "start", value: "name", width: "24%" },
        // { text: "氏名(フリガナ)", align: "start", value: "nameKana", width: "24%" },
        { text: "登記の事由", align: "start", value: "reason", width: "15%" },
        // { text: "登記の事由", align: "start", value: "reason.name", width: "15%" },
        { text: "役員住所", align: "center", value: "data-table-expand", width: "15%" },
        // { text: "役員変更詳細", align: "center", value: "data-table-expand", width: "15%" },
      ],
      desserts: [],
      planDesserts: [],
    };
  },
  mounted() {
    window.addEventListener('scroll', this.scrollWindow);
    // this.modFileViewrHeght();
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })    
  },
  created() {
    this.initialize();
  },
  methods: {

   onResize () {
      // this.isMobile = window.innerWidth < 450
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        this.isMobile = true;
      }
    }, 

   /*
    * 初期表示
    */
    initialize: function() {
      this.setAuthUserInfo();
      this.messageArea = this.$i18n.t('webmsg.mbr510.area');
      this.planMstList = this.$store.getters["master/getPlanMstList"];
      this.reasonMstrList = this.$store.getters["master/getChangeOfficerKbnList"];
      /* データ表示 */
      this.dispInputData();
    },
    setAuthUserInfo : function() {      
      let authInfo = this.setLoginInfoMixin();
      this.username = authInfo['username'];
      this.companyname = authInfo['companyname'];
    },

    /*
    * 「申込」ボタン押下
    */
    requestRegist() {
      if (this.isProcessing) return;
      this.isProcessing = true;
      this.dlgMsgConfirm.isOpen = true;
    },

   /*
    * 「申込」ボタン押下(ファイル情報以外登録)
    */
    request: async function() {

     // 申込情報登録サービス呼び出し
      let responseDto = null;
      let apiErrorInfo = null;
      try {
        let loggedUserInfo = this.$store.getters["authcUser/getLoggedUserInfo"];
        let loginId = loggedUserInfo['id'];
        let apiurl = Constants.getUrlApiMBR510P01(loginId);
        let accessToken = this.$store.getters["authcUser/getAccessToken"];
        // 入力データ
        let data = JSON.stringify(this.createRequestData(this.planMstList));
        // API呼出
        let response = await this.$axios.post(apiurl, data, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        responseDto = response.data;
        // let registerRequestNo = responseDto.data;
        // 完了メッセージ表示
        this.showDialogMsgAfterAPICall(apiErrorInfo, responseDto)
        // if (!this.showDialogMsgAfterAPICall(apiErrorInfo, responseDto)){
        //   //ファイル情報登録
        //   this.requestForFileData(registerRequestNo);
        // }
      } catch(error) {
        console.log(error);
        apiErrorInfo = error;
        this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm110', ['お申込み']);
        this.dlgMsgErr.isOpen = true;
      }
    },

  //  /*
  //   * 「申込」ボタン押下(ファイル情報登録)
  //   */
  //   requestForFileData: async function(requestNo) {

  //     if (this.dispFileInfo == null) {
  //         // ストア初期化
  //         this.$store.commit("requestRegInfo/resetState");
  //         this.dlgMsgCompled.msg = this.$i18n.t('msg.inf.mb020');
  //         this.dlgMsgCompled.isOpen = true;
  //         return;
  //     }
  //     // ファイル情報登録サービス呼び出し
  //     let responseDto = null;
  //     try {
  //       let apiurl = Constants.getUrlApiMBR510P02(requestNo);
  //       let accessToken = this.$store.getters["authcUser/getAccessToken"];
  //       // 入力データ
  //       const requestFileData = new FormData()
  //       requestFileData.append('fileData', this.dispFileInfo)
  //       let data = requestFileData;
  //       // API呼出
  //       let response = await this.$axios.post(apiurl, data, 
  //           {
  //             headers: {"X-AUTH-TOKEN": "Bearer " + accessToken}, 
  //             responseType: "json",
  //           });
  //       responseDto = response.data;
  //       if (responseDto.statusCd != 200) {
  //         this.dlgMsgErr.msg = responseDto.message;
  //         this.dlgMsgErr.isOpen = true;
  //       } else {
  //         // ストア初期化
  //         this.$store.commit("requestRegInfo/resetState");
  //         this.dlgMsgCompled.msg = responseDto.message;
  //         this.dlgMsgCompled.isOpen = true;
  //       }
  //     } catch(error) {
  //       console.log(error);
  //       this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm110', ['お申込み']);
  //       this.dlgMsgErr.isOpen = true;
  //     }
  //   },

    /*
    * 完了メッセージ表示
    */
    showDialogMsgAfterAPICall : function(apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm110', ['お申込み']);
        this.dlgMsgErr.isOpen = true;
        return hasError;
      }
      // APIコール正常
      if (responseData.statusCd != 200) {
        // 処理異常
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          this.dlgMsgErr.msg = Utils.createMsgViewStringForErrList(errorList);
          this.dlgMsgErr.isOpen = true;
          return hasError;
        }  
      } else {
        // ストア初期化
        this.$store.commit("requestRegInfo/resetState");
        this.dlgMsgCompled.msg = responseData.message;
        this.dlgMsgCompled.isOpen = true;
        hasError = false;
      }
      return hasError;
    },

   /*
    * 登録データ生成
    */
    createRequestData: function(planMstList) {
      let requestDto = {};
      // プラン情報 {requestNo:"", planCd:"", planName: "", planPrice:""}
      let requestPlanList = [];
      let requestPlan = {};
      for (const selectedPlanCd of this.selectedPlanIdList) {
        if (Utils.isNullOrEmptyOrUunDef(selectedPlanCd)) {
          continue;
        }
        let searchArry = planMstList.find((v) => v.planCd === selectedPlanCd);
        if (searchArry == null) {
          continue;
        }
        requestPlan = {};
        requestPlan['requestNo'] = "";
        requestPlan['planCd'] = selectedPlanCd;
        requestPlan['planName'] = searchArry.name;
        requestPlan['planPrice'] = searchArry.price;
        requestPlan['supplInfo1'] = searchArry.supplInfo1;
        requestPlanList.push(requestPlan);
      }
      // ファイル情報

      // 役員変更情報
      requestDto['appointDate'] = Utils.removeChar(this.appointDate, '-');
      requestDto['resignDate'] = Utils.removeChar(this.resignDate, '-');
      requestDto['othersDate'] = Utils.removeChar(this.othersDate, '-');
      let listCount = 0;
      let changeOfficerList = [];
      let changeOfficer = {};
      let officer = {};
      // dispOfficerList { no: "", officerNm: "", name: "", nameKana: "", reason:{ cd:"", name:"" }, detailInfo: "" }
      // changeOfficerList {changeNo: "", officialPosition: "", name: "", nameKana: "", changeOfficerClass: "", changeOfficerClassName: "", regmatter:""}
      for (officer of this.dispOfficerList) {
        if (officer['officer'].cd == "" || officer['officer'].cd == null) {
          continue;
        }
        listCount += 1;
        changeOfficer = {};
        changeOfficer['changeNo'] = listCount;
        changeOfficer['officialPositionClass'] = officer['officer'].cd;
        changeOfficer['officialPosition'] = officer['officer'].name;
        // changeOfficer['officialPosition'] = officer['officerNm'];
        changeOfficer['name'] = officer['name'];
        // changeOfficer['nameKana'] = officer['nameKana'];
        changeOfficer['changeOfficerClass'] = officer['reason'].cd;
        changeOfficer['changeOfficerClassName'] = officer['reason'].name;
        // changeOfficer['regmatter'] = Utils.delBrTag(officer['detailInfo']);
        changeOfficer['officerAddress'] = Utils.delBrTag(officer['address']);
        changeOfficerList.push(changeOfficer);
      }
      
      // 登録データ
      requestDto['requestPlanList'] = requestPlanList;
      // requestDto['fileName'] = this.dispFileNm;
      // requestDto['fileSize'] = this.dispFileSize;
      // requestDto['fileData'] = this.dispFileInfo;
      requestDto['changeOfficerList'] = changeOfficerList;
      // requestDto['regmatterInfo'] = this.$store.getters["requestRegInfo/getRegChgInfoInput"];
      return requestDto;
    },

   /*
    * 「戻る」ボタン押下
    */
    back: function() {
      // 遷移元画面へ戻る
      this.$router.push(this.$router.resolve({ name: "MBR400" }).href);
    },

    /*
    * 画面表示用データの生成(申込中情報)
    * データストアデータを表示用データへ編集
    */
    dispInputData: function() {

        /* -- 申込プラン表示情報 -- */
        this.dispSelectPlanPriceList();
        // 選択プランIDリスト取得(ストア)
        this.selectedPlanIdList = this.$store.getters["requestRegInfo/getSelectedPlanIdList"];
        // // 表示用申込プラン情報生成
        // let planNmName = Utils.getPlanInfoForDisp(this.planMstList, this.selectedPlanIdList);
        // this.dispPlanIdNm = "<p>" + planNmName + "</p>"

        // /* -- 登記情報ファイル表示情報 -- */
        // // 登記情報ファイル情報取得(ストア)
        // let selectedFileInfo = this.$store.getters["requestRegInfo/getRegistFileInfo"];
        // // 表示用登記情報ファイル情報生成
        // if (selectedFileInfo != null && selectedFileInfo instanceof File) {
        //   this.dispFileInfo = selectedFileInfo;
        //   this.dispFileNm = selectedFileInfo.name;
        //   this.dispFileSize = selectedFileInfo.size;
        //   // this.dispLastModifiedDate = selectedFileInfo.lastModifiedDate.toISOString().substr(0, 10);

        //   this.dispPdfFileBlobUrl = window.URL.createObjectURL(this.dispFileInfo);
        //   this.dispPdfFileBlobUrl =  this.dispPdfFileBlobUrl + "#toolbar=0&navpanes=0";

        // }
        /* -- 役員情報 -- */
        // 役員情報リスト情報取得(ストア)
        this.dispOfficerList = this.$store.getters["requestRegInfo/getOfficerList"];
        // this.setReasonNmForOfficerList(this.dispOfficerList, this.reasonMstrList);

        this.dispChangeOfficerDate = "";
        this.appointDate = this.$store.getters['requestRegInfo/getAppointDate'];
        this.resignDate = this.$store.getters['requestRegInfo/getResignDate'];
        this.othersDate = this.$store.getters['requestRegInfo/getOthersDate'];
        if (this.appointDate != "" && this.appointDate != null) {
          this.dispChangeOfficerDate = "株主総会・取締役会の開催日付: " + this.appointDate;
        }
        if (this.resignDate != "" && this.resignDate != null) {
          if (this.dispChangeOfficerDate != "") {
            this.dispChangeOfficerDate = this.dispChangeOfficerDate + "<br/>"
          }
          this.dispChangeOfficerDate = this.dispChangeOfficerDate  + "退任等の日付: " + this.resignDate;
        }
        if (this.othersDate != "" && this.othersDate != null) {
          this.dispChangeOfficerDate = "住所移転日付: " + this.othersDate;
        }
        // /* -- 登記変更詳細情報 -- */
        // this.dispRegChgInfo = this.$store.getters["requestRegInfo/getRegChgInfoInput"];
        // if (this.dispRegChgInfo != "") {
        //   // 改行コード置換, pタグ付加
        //   this.dispRegChgInfo = "<p>" + Utils.nl2br(this.dispRegChgInfo) + "</p>";
        // }

        // ファイル情報パネル高さ調整
        // this.modFileViewrHeght();
    },
    // /*
    // * 事由名称取得
    // * @param reasonCd:事由CD
    // * @return 事由名称
    // */
    // getReasonNm(reasonCd) {
    //   let retVal = "";
    //   let searchArry = "";
    //   if (reasonCd != "") {
    //     searchArry = this.reasonMstrList.find((v) => v.cd === reasonCd);
    //   }
    //   if (searchArry != null) {
    //     retVal = searchArry.name;
    //   }
    //   return retVal;
    // },
    // /*
    // * 役員情報事由名称設定
    // * @param officerInfoArry:役員情報
    // * @param reasonMstrInfoArry:事由マスタ
    // */
    // setReasonNmForOfficerList(officerInfoArry, reasonMstrInfoArry) {
    //   if (officerInfoArry == null || reasonMstrInfoArry == null) {
    //     return;
    //   }
    //   officerInfoArry.forEach((officerInfo, index) => {

    //     if (officerInfo.reason.name == "" && officerInfo.reason.cd != "") {
    //       officerInfoArry[index].reason.name = this.getReasonNm(officerInfo.reason.cd)
    //     }
    //   });
    // },
    // /*
    // * ファイル表示パネル高さ調整
    // */
    // modFileViewrHeght: function() {
    //   let iframeFile = document.getElementById("iframeFile");
    //   // iframeFile.style.height = iframeFile.contentWindow.document.body.scrollHeight + "px";
    //   iframeFile.style.height = "80vh";
    // },
    scrollWindow() {
      const top = 200
      this.scroll = window.scrollY
      if (top <= this.scroll) {
        this.buttonActive = true
      } else {
        this.buttonActive = false
      }
    },


    /**
     * 選択プラン明細表示処理
     */
    dispSelectPlanPriceList: function() {
      // 選択プラン
      let selectedPlanIdList = this.$store.getters["requestRegInfo/getSelectedPlanIdList"];
      // 消費税
      let taxInfo = this.$store.getters["master/getTaxRateKbn"];
      let taxRate = Number(taxInfo['value3']);
      this.planDesserts = new Array();
      let planPrice = null;
      let calcRewardSubTotal = 0;
      let calcTaxSubTotal = 0;
      let calcTotal = 0;
      let calcTaxTotal = 0;
      let billAmount = 0;

      for (const selectedPlanCd of selectedPlanIdList) {
        if (Utils.isNullOrEmptyOrUunDef(selectedPlanCd)) {
          continue;
        }
        let searchArry = this.planMstList.find((v) => v.planCd === selectedPlanCd);
        if (searchArry == null) {
          continue;
        }

        planPrice = {};
        planPrice['planName'] = searchArry.name;
        planPrice['planReward'] = Number(searchArry.price);
        planPrice['planTax'] = Number(searchArry.supplInfo1);
        this.planDesserts.push(planPrice);

        calcRewardSubTotal += planPrice['planReward'];
        calcTaxSubTotal +=  planPrice['planTax'];
      }
      // 小計
      planPrice = {};
      planPrice['planName'] = "小計";
      planPrice['planReward'] = calcRewardSubTotal;
      planPrice['planTax'] = calcTaxSubTotal;
      this.planDesserts.push(planPrice);
      // 合計
      calcTotal = calcRewardSubTotal + calcTaxSubTotal;
      planPrice = {};
      planPrice['planName'] = "合計";
      planPrice['planReward'] = calcTotal;
      planPrice['planTax'] = "";
      this.planDesserts.push(planPrice);
      // 消費税
      calcTaxTotal = calcRewardSubTotal * taxRate;
      planPrice = {};
      planPrice['planName'] = taxInfo['name'];
      planPrice['planReward'] = calcTaxTotal;
      planPrice['planTax'] = "";
      this.planDesserts.push(planPrice);
      // 請求金額
      billAmount = calcTotal + calcTaxTotal;
      planPrice = {};
      planPrice['planName'] = "請求金額";
      planPrice['planReward'] = billAmount;
      planPrice['planTax'] = "";
      this.planDesserts.push(planPrice);
    },


  },
};
</script>

<style scoped>
.panel-title {
  color:#000000;
  background-color: #E0E0E0;
  font-size: 1.2em;
  font-weight: lighter;
}
/* 吹き出し */
.balloon {
  position: relative;
  display: inline-block;
  margin: 1.5em 0 1.5em 15px;
  padding: 7px 10px;
  min-width: 60%;
  max-width: 90%;
  color: #555;
  font-size: 16px;
  background: #ffcd93;
  border-radius: 10px;
}

.balloon:before {
  content: "";
  position: absolute;
  top: 25%;
  left: -15px;
  margin-top: -10px;
  border: 5px solid transparent;
  border-right: 10px solid #ffcd93;
}

@media screen and (max-width: 750px) {

}
</style>
